import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function FooterSection() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-stone-900 py-12 px-4 text-center" data-id="element-64">
        <div className="max-w-4xl mx-auto" data-id="element-65">
          <p className="text-stone-400 mb-4" data-id="element-66">
            © 2026 Memoria de Oro. Todos los derechos reservados.
          </p>
          <p className="text-stone-500 text-sm max-w-2xl mx-auto mb-6" data-id="element-67">
            Este producto es educativo y no reemplaza el consejo médico
            profesional.
          </p>
          <div className="flex items-center justify-center gap-6" data-id="element-68">
            <button onClick={() => setActiveModal('privacy')} className="text-stone-400 hover:text-amber-400 text-sm underline underline-offset-2 transition-colors duration-200" data-id="element-69">
              Política de Privacidad
            </button>
            <span className="text-stone-600" data-id="element-70">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-stone-400 hover:text-amber-400 text-sm underline underline-offset-2 transition-colors duration-200" data-id="element-71">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-72">
          <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-73">
            <div className="flex items-center justify-between px-6 py-4 border-b border-stone-200" data-id="element-74">
              <h3 className="font-serif text-xl font-bold text-stone-900" data-id="element-75">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h3>
              <button onClick={() => setActiveModal(null)} className="text-stone-400 hover:text-stone-700 transition-colors p-1 rounded-full hover:bg-stone-100" data-id="element-76">
                <XIcon className="w-5 h-5" data-id="element-77" />
              </button>
            </div>

            <div className="px-6 py-6 overflow-y-auto text-left text-stone-700 text-sm leading-relaxed space-y-4" data-id="element-78">
              {activeModal === 'privacy' ? <PrivacyContent data-id="element-79" /> : <TermsContent data-id="element-80" />}
            </div>

            <div className="px-6 py-4 border-t border-stone-200 text-right" data-id="element-81">
              <button onClick={() => setActiveModal(null)} className="bg-amber-500 hover:bg-amber-600 text-stone-900 font-semibold py-2 px-6 rounded-full transition-colors duration-200 text-sm" data-id="element-82">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-stone-500 text-xs" data-id="element-83">
        Última actualización: 27 de marzo de 2026
      </p>

      <h4 className="font-semibold text-stone-900 text-base" data-id="element-84">
        1. Información que Recopilamos
      </h4>
      <p data-id="element-85">
        Recopilamos únicamente la información necesaria para procesar su compra
        y entregar el producto digital, incluyendo: nombre, dirección de correo
        electrónico y datos de pago. No almacenamos información de tarjetas de
        crédito directamente; estos datos son procesados de forma segura por
        nuestro proveedor de pagos.
      </p>

      <h4 className="font-semibold text-stone-900 text-base" data-id="element-86">
        2. Uso de la Información
      </h4>
      <p data-id="element-87">
        Utilizamos su información personal exclusivamente para: procesar y
        entregar su compra, enviar confirmaciones de pedido, proporcionar
        soporte al cliente y enviar actualizaciones relacionadas con el producto
        (si usted lo autoriza).
      </p>

      <h4 className="font-semibold text-stone-900 text-base" data-id="element-88">
        3. Protección de Datos
      </h4>
      <p data-id="element-89">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger su información personal contra acceso no autorizado, pérdida o
        alteración. Utilizamos cifrado SSL para todas las transmisiones de
        datos.
      </p>

      <h4 className="font-semibold text-stone-900 text-base" data-id="element-90">
        4. Compartir Información
      </h4>
      <p data-id="element-91">
        No vendemos, alquilamos ni compartimos su información personal con
        terceros, excepto cuando sea necesario para procesar su pago o cuando la
        ley lo requiera.
      </p>

      <h4 className="font-semibold text-stone-900 text-base" data-id="element-92">
        5. Sus Derechos
      </h4>
      <p data-id="element-93">
        Usted tiene derecho a acceder, corregir o eliminar su información
        personal en cualquier momento. Para ejercer estos derechos, puede
        contactarnos a través de los canales indicados en nuestro sitio.
      </p>

      <h4 className="font-semibold text-stone-900 text-base" data-id="element-94">6. Cookies</h4>
      <p data-id="element-95">
        Nuestro sitio puede utilizar cookies para mejorar su experiencia de
        navegación. Puede configurar su navegador para rechazar cookies, aunque
        esto podría afectar algunas funcionalidades del sitio.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-stone-500 text-xs" data-id="element-96">
        Última actualización: 27 de marzo de 2026
      </p>

      <h4 className="font-semibold text-stone-900 text-base" data-id="element-97">
        1. Aceptación de los Términos
      </h4>
      <p data-id="element-98">
        Al acceder y utilizar este sitio web y adquirir nuestros productos,
        usted acepta estar sujeto a estos Términos y Condiciones. Si no está de
        acuerdo con alguna parte de estos términos, le rogamos que no utilice
        nuestro sitio.
      </p>

      <h4 className="font-semibold text-stone-900 text-base" data-id="element-99">
        2. Producto Digital
      </h4>
      <p data-id="element-100">
        "Memoria de Oro: Guía Anti-Olvidos" es un producto digital educativo. El
        acceso se proporciona de forma inmediata tras la confirmación del pago.
        Este producto tiene fines informativos y educativos únicamente.
      </p>

      <h4 className="font-semibold text-stone-900 text-base" data-id="element-101">
        3. Aviso de Salud
      </h4>
      <p data-id="element-102">
        Este producto no constituye consejo médico profesional y no pretende
        diagnosticar, tratar, curar ni prevenir ninguna enfermedad. Siempre
        consulte con un profesional de la salud calificado antes de realizar
        cambios en su rutina de salud.
      </p>

      <h4 className="font-semibold text-stone-900 text-base" data-id="element-103">
        4. Propiedad Intelectual
      </h4>
      <p data-id="element-104">
        Todo el contenido del producto, incluyendo textos, imágenes y diseño,
        está protegido por derechos de autor. Queda prohibida la reproducción,
        distribución o reventa del material sin autorización expresa.
      </p>

      <h4 className="font-semibold text-stone-900 text-base" data-id="element-105">
        5. Política de Reembolso
      </h4>
      <p data-id="element-106">
        Debido a la naturaleza digital del producto y su entrega inmediata,
        todas las ventas son finales. Sin embargo, si experimenta problemas
        técnicos para acceder al contenido, nos comprometemos a resolverlos de
        forma oportuna.
      </p>

      <h4 className="font-semibold text-stone-900 text-base" data-id="element-107">
        6. Limitación de Responsabilidad
      </h4>
      <p data-id="element-108">
        Los resultados pueden variar de persona a persona. No garantizamos
        resultados específicos derivados del uso de este producto. El usuario
        asume la responsabilidad total por el uso que haga del contenido.
      </p>

      <h4 className="font-semibold text-stone-900 text-base" data-id="element-109">
        7. Modificaciones
      </h4>
      <p data-id="element-110">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones entrarán en vigor inmediatamente después de
        su publicación en el sitio web.
      </p>
    </>;
}